import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatDividerModule } from '@angular/material/divider';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';
import { BranchAvatarModule } from '@portal-core/branches/components/branch-avatar/branch-avatar.module';
import { BuildAvatarModule } from '@portal-core/builds/components/build-avatar/build-avatar.module';
import { CommitAvatarModule } from '@portal-core/commits/components/commit-avatar/commit-avatar.module';
import { DestinationAvatarModule } from '@portal-core/destinations/components/destination-avatar/destination-avatar.module';
import { LicenseUserAvatarModule } from '@portal-core/license-users/components/license-user-avatar/license-user-avatar.module';
import { ProjectAvatarModule } from '@portal-core/projects/components/project-avatar/project-avatar.module';
import { PublicationProgressBarModule } from '@portal-core/publications/components/publication-progress-bar/publication-progress-bar.module';
import { SiteAvatarModule } from '@portal-core/sites/components/site-avatar/site-avatar.module';
import { SiteAsyncModule } from '@portal-core/sites/pipes/site-async/site-async.module';
import { TargetAvatarModule } from '@portal-core/targets/components/target-avatar/target-avatar.module';
import { FlareAvatarModule } from '@portal-core/users/components/flare-avatar/flare-avatar.module';
import { FlareOnlineAvatarModule } from '@portal-core/users/components/flare-online-avatar/flare-online-avatar.module';
import { PublicationOverviewComponent } from './publication-overview.component';

@NgModule({
  declarations: [PublicationOverviewComponent],
  imports: [
    BranchAvatarModule,
    PublicationProgressBarModule,
    CommitAvatarModule,
    DestinationAvatarModule,
    CommonModule,
    FlareAvatarModule,
    BuildAvatarModule,
    FlareOnlineAvatarModule,
    MatDividerModule,
    MatIconModule,
    MatTooltipModule,
    ProjectAvatarModule,
    SiteAvatarModule,
    TargetAvatarModule,
    SiteAsyncModule,
    LicenseUserAvatarModule
  ],
  exports: [PublicationOverviewComponent]
})
export class PublicationOverviewModule { }
